module.exports = __webpack_public_path__ + "img/department-process.94360832.png";